'use strict';

// Initialize Firebase
const config = {
    apiKey: "AIzaSyDO-xGv-C8SJJHSk3-ySxEWC7Bb21GyV-I",
    authDomain: "potsdam-billard-festival.firebaseapp.com",
    databaseURL: "https://potsdam-billard-festival.firebaseio.com",
    projectId: "potsdam-billard-festival",
    storageBucket: "potsdam-billard-festival.appspot.com",
    messagingSenderId: "977698574702"
};

const fb = require('firebase');
const firebaseFirestore = require('firebase/firestore');
const firebaseFunctions = require('firebase/functions');

fb.initializeApp(config);
const db = fb.firestore();
const func = fb.functions();

const API = "https://us-central1-potsdam-billard-festival.cloudfunctions.net/api";
const API_REGISTER = API + "/register";



function getFestival(slug) {
    return db.collection("tournaments").where("slug", "==", slug).limit(1).get();
}

function register(tournamentId, form, callback) {
    
    if (! tournamentId || !form) {
        console.log("invalid params: tournamentId", tournamentId, "form", form);
        callback(false);
        return;
    }
    if (!form.block || !form.block.id) {
        console.error("invalid block: ", "'" + form.block + "'");
        callback(false);
        return;
    }
    
    var data = {
        tournamentId: tournamentId,
        blockId: form.block.id,
        surname: (form.surname || "").trim(),
        forename: (form.forename || "").trim(),
        gender: (form.gender || "").trim().charAt(0),
        dob: (form.dob || "").trim(),
        shirtSize: (form.shirtSize || "").trim().toUpperCase(),
        club: form.club || "ohne", // (form.club || " ").trim(),
        zip: (form.zip || "").trim(),
        city: (form.city || "").trim(),
        phone: (form.phone || "").trim(),
        email: (form.email || "").trim()
    };
    
    var registerCall = func.httpsCallable('api/register');
    registerCall(data).then(function(result) {
        console.log("register result", result);
        callback(true, result);
    }).catch(function(result) {
        callback(false, result);
    });
 
}

module.exports = {
    getFestival: getFestival,
    getCurrentFestival: () => {
        return getFestival(new Date().getYear())
    },
    register: register
}